import { TracePageRenderRQ } from '@wheely/web-tracing';
import { useSelector } from 'react-redux';
import { useSyncExternalStore } from 'use-sync-external-store/shim';

import { getPartner } from '@/modules/partner/store/selectors';
import { getUserData } from '@/modules/user/store/selectors';
import { FetchingStatusStoreInstance } from '@/shared/store/fetching-status-store';

export const Tracer = () => {
  const user = useSelector(getPartner);
  const me = useSelector(getUserData);

  const isFetching = useSyncExternalStore(
    FetchingStatusStoreInstance.subscribe,
    FetchingStatusStoreInstance.getSnapshot,
  );

  // user.id holds the partner, empty for a chauffeur without one; enduser.id names the account itself.
  return (
    <TracePageRenderRQ
      isFetching={isFetching}
      commonAttributes={{ 'user.id': user?.id, 'enduser.id': me.userId || undefined }}
    />
  );
};
